import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Home from './pages/Home'
import Desktop9 from "./pages/Desktop9";
import Desktop1 from "./pages/Desktop1";
import RootLayout from "./root/RootLayout";
import Desktop3 from "./pages/Desktop3";
import Desktop5 from "./pages/Desktop5";
import Desktop6 from "./pages/Desktop6";
import Desktop2 from "./pages/Desktop2";


const router = createBrowserRouter(createRoutesFromElements(
  <Route path="/" element={<RootLayout/>}>
    <Route index element={<Home/>}></Route>
    <Route path="/Desktop9" element={<Desktop9/>}></Route>
    <Route path="/Desktop2" element={<Desktop2/>}></Route>
    <Route path="/Desktop1" element={<Desktop1/>}></Route>
    <Route path="/Desktop3" element={<Desktop3/>}></Route>
    <Route path="/Desktop5" element={<Desktop5/>}></Route>
    <Route path="/Desktop6" element={<Desktop6/>}></Route>
  </Route>
))


function App() {
  return (
    <RouterProvider router={router}/>
  );
}

export default App;
